import PropTypes from "prop-types";
import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import BootstrapTable from "react-bootstrap/Table";
import { FormattedMessage } from "react-intl";
import { findAnswer } from "../../../../utils/QuestionUtils";
import { Alert } from "react-bootstrap";

const RenderAnswer = ({ answers, field, useValue, empty }) => {
  const result = findAnswer(answers, { name: field });

  return (
    (result && result[useValue ? "value" : "text"]) ||
    (!empty && <FormattedMessage id="survey.editor.toolbox.projectData.emptyInfo" />)
  );
};

const ProjectData = ({ questionAnswer }) => {
  let answers = [];
  let ordered = [];

  if (questionAnswer && questionAnswer.answers) {
    answers = questionAnswer.answers;
    // We are creating new array of users to be able to sort it later
    if (questionAnswer.rows) {
      questionAnswer.rows.forEach((row) =>
        ordered.push({
          firstName: findAnswer(answers, {
            row: row,
            column: { name: "firstname" }
          }).text,
          lastName: findAnswer(answers, {
            row: row,
            column: { name: "lastname" }
          }).text,
          email: findAnswer(answers, {
            row: row,
            column: { name: "email" }
          }).text,
          role: findAnswer(answers, {
            row: row,
            column: { name: "role" }
          }).text
        })
      );
    }

    // Reverse order so project lead is going on top
    ordered.sort((a, b) => b.role.localeCompare(a.role));
  }

  return (
    <>
      <Row>
        <Col lg={12} md={12} sm={12}>
          <h5>
            <FormattedMessage id="survey.editor.toolbox.projectData.information" />
          </h5>
          <BootstrapTable responsive>
            <tbody>
              <tr>
                <th>
                  <FormattedMessage id="survey.editor.toolbox.projectData.projectName" />
                </th>
                <td>
                  <RenderAnswer answers={answers} field="project" />
                </td>
              </tr>
              <tr>
                <th>
                  <FormattedMessage id="survey.editor.toolbox.projectData.projectNumber" />
                </th>
                <td>
                  <RenderAnswer answers={answers} field="project" useValue />
                </td>
              </tr>
              <tr>
                <th>
                  <FormattedMessage id="survey.editor.toolbox.projectData.institution" />
                </th>
                <td>
                  <RenderAnswer answers={answers} field="university" />
                </td>
              </tr>
              <tr>
                <th>
                  <FormattedMessage id="survey.editor.toolbox.projectData.faculty" />
                </th>
                <td>
                  <RenderAnswer answers={answers} field="faculty" />
                </td>
              </tr>
              <tr>
                <th>
                  <FormattedMessage id="survey.editor.toolbox.projectData.firstFundingYear" />
                </th>
                <td>
                  <RenderAnswer answers={answers} field="fundingBegin" useValue />
                </td>
              </tr>
              <tr>
                <th>
                  <FormattedMessage id="survey.editor.toolbox.projectData.lastFundingYear" />
                </th>
                <td>
                  <RenderAnswer answers={answers} field="fundingEnd" useValue />
                </td>
              </tr>
              <tr>
                <th>
                  <FormattedMessage id="survey.editor.toolbox.projectData.reportingYear" />
                </th>
                <td>
                  <RenderAnswer answers={answers} field="reportingYear" />
                </td>
              </tr>
            </tbody>
          </BootstrapTable>
          <h5>
            <FormattedMessage id="survey.editor.toolbox.projectData.contact" />
          </h5>
          {ordered && ordered.length > 0 ? (
            <BootstrapTable borderless striped bordered>
              <thead>
                <tr>
                  <th>
                    <FormattedMessage id="survey.editor.toolbox.projectData.firstName" />
                  </th>
                  <th>
                    <FormattedMessage id="survey.editor.toolbox.projectData.name" />
                  </th>
                  <th>
                    <FormattedMessage id="survey.editor.toolbox.projectData.email" />
                  </th>
                  <th>
                    <FormattedMessage id="survey.editor.toolbox.projectData.role" />
                  </th>
                </tr>
              </thead>
              <tbody>
                {ordered.map((row, i) => (
                  <tr key={i}>
                    <td className="text-truncate">{row.firstName}</td>
                    <td className="text-truncate">{row.lastName}</td>
                    <td className="text-truncate">{row.email}</td>
                    <td className="text-truncate">
                      <FormattedMessage id={`survey.editor.toolbox.projectData.${row.role}`} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </BootstrapTable>
          ) : (
            <Alert variant="light">
              <FormattedMessage id="survey.editor.toolbox.projectData.no.contact" />
            </Alert>
          )}
        </Col>
      </Row>
    </>
  );
};

export default ProjectData;

ProjectData.propTypes = {
  question: PropTypes.object,
  questionAnswer: PropTypes.object
};
